'use strict';
import {combineReducers} from 'redux';
import {
  ASSET_ITEM_NAME,
  ASSET_PROJECT_ITEM_NAME,
  ORG_PROFILE_ITEM_NAME,
  ORGANIZATION_ITEM_NAME,
  PROJECT_ITEM_NAME,
} from '../redux/state';
import {assetProjectReduxItem} from '../redux/assetProjectReduxItem';
import {assetReduxItem} from '../redux/assetReduxItem';
import {organizationReduxItem} from '../redux/organizationReduxItem';
import {orgProfileReduxItem} from '../redux/orgProfileReduxItem';
import {projectReduxItem} from '../redux/projectReduxItem';
import {lastAccessedAssets, lastAccessedOrganizations, lastAccessedProjects} from './lastAccessed';
import {modelAsset} from './modelAsset';
import {modelAssetProject} from './modelAssetProject';
import {modelOrganization} from './modelOrganization';
import {modelOrganizationProfile} from './modelOrganizationProfile';
import {modelProject} from './modelProject';
import {user, userProfile} from './modelUser';

/**
 * TODO: rename and/or figure out how to incorporate with redux to provide type hints
 * @typedef {Object} AppState
 * @property {Object} user
 * @property {Object} organization
 * @property {Object} orgProfile
 * @property {Object} project
 * @property {Object} asset
 * @property {Object} assetProject
 */

export const model = combineReducers({
  asset: modelAsset,
  assetProject: modelAssetProject,
  organization: modelOrganization,
  orgProfile: modelOrganizationProfile,
  project: modelProject,
  user,
  userProfile,
  observables: combineReducers({
    [ASSET_PROJECT_ITEM_NAME]: assetProjectReduxItem.reducers.reducer,
    [ASSET_ITEM_NAME]: assetReduxItem.reducers.reducer,
    [ORGANIZATION_ITEM_NAME]: organizationReduxItem.reducers.reducer,
    [ORG_PROFILE_ITEM_NAME]: orgProfileReduxItem.reducers.reducer,
    [PROJECT_ITEM_NAME]: projectReduxItem.reducers.reducer,
  }),
});

export const userPrefs = combineReducers({
  lastAccessedOrganizations,
  lastAccessedProjects,
  lastAccessedAssets,
});



// WEBPACK FOOTER //
// ./src/js/app/model/reducers/index.js